import * as RulesConstants from './RulesConstants';
import {
  STATUS_FAILURE,
  STATUS_PENDING,
  STATUS_SUCCESS,
} from "Common/constants/commonConstants";

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
  ruleList:[],
  hasMoreRules: false,
  fetchRulesListStatus: STATUS_SUCCESS,
  pendingDays: RulesConstants.DEFAULT_DAYS,
  pendingActionType: RulesConstants.DEFAULT_ACTION_TYPE,
  isOpenExpressionPopup: false,
  expressionMessage: "",
  expressionRuleName: "",
  serviceMaxURL: "",
}

export default function RulesReducer(state = initialState, action) {
  switch (action.type) {
    case RulesConstants.FETCH_RULE_LIST_REQUEST: {
      return assign({}, state, {
        fetchRulesListStatus: STATUS_PENDING,
      });
    }
    case RulesConstants.FETCH_RULE_LIST_SUCCESS: {
      return assign({}, state, {
        fetchRulesListStatus: STATUS_SUCCESS,
        hasMoreRules: action?.result?.hasMore,
        ruleList: action?.offset === 0 ? (action?.result?.rules || []) : [...state.ruleList, ...(action?.result?.rules || [])]
      });
    }
    case RulesConstants.FETCH_RULE_LIST_FAILURE: {
      return assign({}, state, {
        fetchRulesListStatus: STATUS_FAILURE,
      });
    }
    case RulesConstants.SET_PENDING_DAYS: {
      return assign({}, state, {
        pendingDays: action.days
      });
    }
    case RulesConstants.SET_ACTION_TYPE: {
      return assign({}, state, {
        pendingActionType: action.actionType || RulesConstants.DEFAULT_ACTION_TYPE,
      });
    }
    case RulesConstants.RESET_RULE_LIST_DATA: {
      return assign({}, state, {
        fetchRulesListStatus: "",
        hasMoreRules: false,
        ruleList: [],
        isOpenExpressionPopup: false,
        expressionMessage: "",
        expressionRuleName: "",
      });
    }
    case RulesConstants.OPEN_EXPRESSION_POPUP: {
      return assign({}, state, {
        isOpenExpressionPopup: true,
        expressionMessage: action?.payload?.message || "",
        expressionRuleName: action?.payload?.expressionRuleName || "Expression",
      });
    }
    case RulesConstants.CLOSE_EXPRESSION_POPUP: {
      return assign({}, state, {
        isOpenExpressionPopup: false,
        expressionMessage: "",
        expressionRuleName: "",
      });
    }
    case RulesConstants.FETCH_SERVICE_MAX_URL_SUCCESS: {
      return assign({}, state, {
        serviceMaxURL: action.url,
      });
    }
    default:
      return state;

  }

}